import React, { useState, useEffect, useRef } from "react";
import { auth, db } from "./firebase";
import { doc, updateDoc } from "firebase/firestore";
import { useTranslation } from 'react-i18next';

export default function Onboarding({ onClose }) {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef(0);

  const slides = [
    {
      title: t('onboarding.slide1.title'),
      description: t('onboarding.slide1.description'),
      image: "/onboarding-slide1.png",
    },
    {
      title: t('onboarding.slide2.title'),
      description: t('onboarding.slide2.description'),
      image: "/onboarding-slide2.png",
    },
    {
      title: t('onboarding.slide3.title'),
      description: t('onboarding.slide3.description'),
      image: "/onboarding-slide3.png",
    },
    {
      title: t('onboarding.slide4.title'),
      description: t('onboarding.slide4.description'),
      image: "/onboarding-slide4.png",
    },
  ];

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const deltaX = e.changedTouches[0].clientX - touchStartX.current;
    if (deltaX > 60 && currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    } else if (deltaX < -60 && currentIndex < slides.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const handleNext = async () => {
    if (currentIndex < slides.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      // Mark user as no longer new in Firestore
      const user = auth.currentUser;
      if (user) {
        const userRef = doc(db, 'users', user.uid);
        await updateDoc(userRef, { isNewUser: false });
      }
      localStorage.setItem("hasSeenOnboarding", "true");
      onClose();
    }
  };

  useEffect(() => {
    // Blocca scroll dietro al modale
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={styles.overlay}>
      <div
        style={styles.modal}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div style={styles.skip} onClick={async () => {
          // Mark user as no longer new in Firestore
          const user = auth.currentUser;
          if (user) {
            const userRef = doc(db, 'users', user.uid);
            await updateDoc(userRef, { isNewUser: false });
          }
          localStorage.setItem("hasSeenOnboarding", "true");
          onClose();
        }}>
        {t('onboarding.skip')}</div>

        <img src={slides[currentIndex].image} alt="" style={styles.image} />

        <h2 style={styles.title}>{slides[currentIndex].title}</h2>
        <p style={styles.description}>{slides[currentIndex].description}</p>

        <div style={styles.dots}>
          {slides.map((_, index) => (
            <div
              key={index}
              style={{
                ...styles.dot,
                backgroundColor: currentIndex === index ? "#111" : "#ccc",
              }}
            />
          ))}
        </div>

        <button onClick={handleNext} style={styles.primaryButton}>
          {currentIndex === slides.length - 1 ? t('onboarding.start') : t('onboarding.next')}
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(3px)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Poppins, sans-serif",
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding: "24px",
    width: "92%",
    maxWidth: "300px",
    textAlign: "center",
    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
    position: "relative",
  },
  skip: {
    position: "absolute",
    top: "14px",
    right: "20px",
    fontSize: "13px",
    color: "#111",
    cursor: "pointer",
  },
  image: {
    width: "100%",
    maxWidth: "240px",
    height: "180px",
    objectFit: "contain",
    margin: "0 auto 24px",
    display: "block",
  },
  title: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#111",
    marginBottom: "10px",
  },
  description: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "24px",
    lineHeight: "1.5",
  },
  dots: {
    display: "flex",
    justifyContent: "center",
    gap: "6px",
    marginBottom: "24px",
  },
  dot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    transition: "background-color 0.3s",
  },
  primaryButton: {
    backgroundColor: "#111",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "10px 24px",
    cursor: "pointer",
    fontSize: "14px",
    width: "100%",
  },
};